import React, { useState, useEffect } from 'react';

import { Dropdown, FormInput_text } from "components";

import { convertArrayToDropdownArrayFormat, func_validation, getObjectPropertyValue, isArrayNotEmpty, isNumberValid, isStringTrimNotEmpty, getObjectPropertyValue_stringTrimNotEmpty } from "functions";

export function useCompanyInputs(props) {
    // Props
    
    const {
        isEditing,
        billingSetup,
        isFormSubmissionAttempted,
        
        comIdList,
        accountCodeList,
        // dealerCodeList,
        // salesPersonCodeList,
        fullAgentCodeList,

        // Functions
        getFullAgentCodeList = () => {},
    } = props;

    let companyId_original = getObjectPropertyValue(billingSetup, "CompanyId");
    let accountCode_original = getObjectPropertyValue(billingSetup, "AccountCode");
    let dealerCode_original = getObjectPropertyValue(billingSetup, "DealerCode");
    let salesPersonCode_original = getObjectPropertyValue(billingSetup, "SalesPersonCode");
    let currencyCode_init = getObjectPropertyValue_stringTrimNotEmpty(billingSetup, "CurrencyCode", "MYR");


    // States
    const [companyId, setCompanyId] = useState(companyId_original);
    const [accountCode, setAccountCode] = useState(accountCode_original);
    const [isTypingAccountCode, setIsTypingAccountCode] = useState();
    const [dealerCode, setDealerCode] = useState(dealerCode_original);
    const [salesPersonCode, setSalesPersonCode] = useState(salesPersonCode_original);
    const [isAnyInputChanged, setIsAnyInputChanged] = useState(false);
    const [dealerCodeList, setDealerCodeList] = useState();
    const [salesPersonCodeList, setSalesPersonCodeList] = useState();
    const [currencyCode, setCurrencyCode] = useState(currencyCode_init);

    // Check for changes in input from initial
    useEffect(() => {
        let isNotChangedFromOriginal = (
            companyId === companyId_original &&
            accountCode === accountCode_original &&
            dealerCode === dealerCode_original &&
            salesPersonCode === salesPersonCode_original &&
            currencyCode === currencyCode_init
        );

        let isChangedFromEmpty = (
            companyId || accountCode || dealerCode || salesPersonCode || currencyCode
        );

        setIsAnyInputChanged(isEditing? !isNotChangedFromOriginal: isChangedFromEmpty);    
    }, [
        companyId, accountCode, dealerCode, salesPersonCode, currencyCode
    ]);

    // Get Dealer and Sales Person Codes FULL list (Not just from existing setups)
    useEffect(() => {
        getFullAgentCodeList();
    }, []);

    useEffect(() => {
        if(fullAgentCodeList){
        const tempDealerCode = fullAgentCodeList.partnerList;
        const tempSalesPersonCode = fullAgentCodeList.salesRepList;
      
        if (isArrayNotEmpty(tempDealerCode)) {
            let dealerList = []
            tempDealerCode.map((aDealerCode) => {
                if (aDealerCode.indexOf("3100-") != -1) {
                    dealerList.push(aDealerCode);
                }
            })
            setDealerCodeList(dealerList);
        }

        if (isArrayNotEmpty(tempSalesPersonCode)) {
            let salesPersonList = [];
            tempSalesPersonCode.map((aSalesPerson) => {

                salesPersonList.push(aSalesPerson);
            })
            setSalesPersonCodeList(salesPersonList);
        }
    }
    }, [fullAgentCodeList]);

    // Display
    let display = (
        <div className={"recursiveBillingSetupAccountUpdate-company d-flex flex-wrap"}>
            {/* Company Id */}
            <Dropdown
                className={"recursiveBillingSetupAccountUpdate-companyId col-3"}
                label={"Company ID"}
                isInputRequired

                selectedValueClassName={"recursiveBillingSetupAccountUpdate-companyId-input"}

                options={comIdList}
                selectedValue_default={companyId}
                onChange={setCompanyId}

                errorMsg={"Required"}

                isFormSubmissionAttempted={isFormSubmissionAttempted}
                isInputDigitOnly isSearchable
                isInputValueTrim_onChange

                isDisabled={isEditing}
            />

            {/* Account Code */}
            <Dropdown
                className={"recursiveBillingSetupAccountUpdate-accountCode col-3"}
                label={"Account Code"}
                isInputRequired

                selectedValueClassName={"recursiveBillingSetupAccountUpdate-accountCode-input"}

                options={accountCodeList}
                selectedValue_default={accountCode}
                onChange={(value) => {
                    setIsTypingAccountCode(true);
                    setAccountCode(value);
                }}
                onBlur={() => {
                    setIsTypingAccountCode(false);
                }}

                errorMsg={"Required"}

                isFormSubmissionAttempted={isFormSubmissionAttempted}
                isSearchable

                isDisabled={isEditing}
            />

            {/* Dealer Code */}
            <Dropdown
                className={"recursiveBillingSetupAccountUpdate-dealerCode col-3"}
                label={"Dealer Code"}

                selectedValueClassName={"recursiveBillingSetupAccountUpdate-dealerCode-input"}

                options={convertArrayToDropdownArrayFormat(dealerCodeList)}
                selectedValue_default={dealerCode}
                onChange={setDealerCode}

                isSearchable
                isDisabled={isEditing}
            />

            {/* Currency Code */}
            <FormInput_text  
                inputLabel={"Currency Code"}

                className={"recursiveBillingSetupAccountUpdate-currencyCode col-3"}
                inputValue_default={currencyCode} 

                isInputBlurHandlingRequired
                handleInputBlurExtend={(value) => { setCurrencyCode(value); }}

                inputMaxLength={3} 

                customErrorMsgDefault={"Required"}
                isFormSubmissionAttempted={isFormSubmissionAttempted} 

                isInputValueTrim_onChange
                isMarginBtmOptional

                isInputDisabled={isEditing}
            />

            {/* Sales Person Code */}
            <Dropdown
                className={"recursiveBillingSetupAccountUpdate-salesPersonCode col-6"}
                label={"Sales Person Code"}

                selectedValueClassName={"recursiveBillingSetupAccountUpdate-salesPersonCode-input"}

                options={convertArrayToDropdownArrayFormat(salesPersonCodeList)}
                selectedValue_default={salesPersonCode}
                onChange={setSalesPersonCode}

                isSearchable
                isDisabled={isEditing}
            />
        </div>
    );

    let isEveryInputValid = (
        isNumberValid(companyId) &&
        isStringTrimNotEmpty(accountCode) &&
        // isStringTrimNotEmpty(dealerCode) &&
        // isStringTrimNotEmpty(salesPersonCode) &&
        isStringTrimNotEmpty(currencyCode)
    );

    let companyDetails = {
        CompanyId: companyId,
        AccountCode: accountCode,
        DealerCode: isStringTrimNotEmpty(dealerCode)? dealerCode:"",
        SalesPersonCode: isStringTrimNotEmpty(salesPersonCode)? salesPersonCode:"",
        CurrencyCode: currencyCode,
    }

    return {
        companyId, companyDetails,
        isTypingAccountCode,

        isEveryInputValid,
        isAnyInputChanged,

        display
    }
}